import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Espa\xF1ol",
  code: "es",
  messages: {
    alert: {
      close: "Cerrar"
    },
    authForm: {
      hidePassword: "Ocultar contrase\xF1a",
      showPassword: "Mostrar contrase\xF1a",
      submit: "Continuar"
    },
    banner: {
      close: "Cerrar"
    },
    calendar: {
      nextMonth: "Mes siguiente",
      nextYear: "A\xF1o siguiente",
      prevMonth: "Mes anterior",
      prevYear: "A\xF1o anterior"
    },
    carousel: {
      dots: "Elegir diapositiva a mostrar",
      goto: "Ir a la diapositiva {slide}",
      next: "Siguiente",
      prev: "Anterior"
    },
    chatPrompt: {
      placeholder: "Escribe tu mensaje aqu\xED..."
    },
    chatPromptSubmit: {
      label: "Enviar"
    },
    colorMode: {
      dark: "Oscuro",
      light: "Claro",
      switchToDark: "Cambiar a modo oscuro",
      switchToLight: "Cambiar a modo claro",
      system: "Sistema"
    },
    commandPalette: {
      back: "Atr\xE1s",
      close: "Cerrar",
      noData: "Sin datos",
      noMatch: "No hay datos coincidentes",
      placeholder: "Escribe un comando o busca..."
    },
    contentSearch: {
      links: "Enlaces",
      theme: "Tema"
    },
    contentSearchButton: {
      label: "Buscar..."
    },
    contentToc: {
      title: "En esta p\xE1gina"
    },
    dashboardSearch: {
      theme: "Tema"
    },
    dashboardSearchButton: {
      label: "Buscar..."
    },
    dashboardSidebarCollapse: {
      collapse: "Colapsar barra lateral",
      expand: "Expandir barra lateral"
    },
    dashboardSidebarToggle: {
      close: "Cerrar barra lateral",
      open: "Abrir barra lateral"
    },
    error: {
      clear: "Volver al inicio"
    },
    fileUpload: {
      removeFile: "Eliminar {filename}"
    },
    header: {
      close: "Cerrar men\xFA",
      open: "Abrir men\xFA"
    },
    inputMenu: {
      create: 'Crear "{label}"',
      noData: "Sin datos",
      noMatch: "No hay datos coincidentes"
    },
    inputNumber: {
      decrement: "Decrementar",
      increment: "Incrementar"
    },
    modal: {
      close: "Cerrar"
    },
    pricingTable: {
      caption: "Comparaci\xF3n de planes de precios"
    },
    prose: {
      codeCollapse: {
        closeText: "Colapsar",
        name: "c\xF3digo",
        openText: "Expandir"
      },
      collapsible: {
        closeText: "Ocultar",
        name: "propiedades",
        openText: "Mostrar"
      },
      pre: {
        copy: "Copiar c\xF3digo al portapapeles"
      }
    },
    selectMenu: {
      create: 'Crear "{label}"',
      noData: "Sin datos",
      noMatch: "No hay datos coincidentes",
      search: "Buscar..."
    },
    slideover: {
      close: "Cerrar"
    },
    table: {
      noData: "Sin datos"
    },
    toast: {
      close: "Cerrar"
    }
  }
});
